<template>
  <a-config-provider :locale="locale">
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
export default {
  name: 'App',
  data () {
    return {
      locale: zhCN,
    }
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
  height:100%;
}
/* .index-tab-active {
  background-color: #566185 !important;
}
.ant-layout-sider {
  background-color: #566185 !important;
}
.ant-menu-item-selected {
  background-color: #717c9d !important;
}
.ant-menu {
  background-color: #566185 !important;
}
.ant-menu-sub {
   background-color: #566185 !important;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue